<template>
    <div>
        <loading :active.sync="is_loading" :can-cancel="true" :is-full-page="true">
        </loading>
        <!-- Navbar -->
        <Navbar />

        <!-- Sidebar -->
        <SidebarSpatial />

        <main id="main" class="main document">
            <!-- Breadcomp -->
            <Breadcrumb :links="[{url: '/dashboard', text:'Home'}, {url: '/telemeteri/', text: 'Telemetri'}, {url:'#', text: 'Dokumentasi'}]" />
            <!-- END OF BREADCOMP -->

            <section class="section dashboard">
                <div class="row">
                    <div class="col-lg-4">
                        <div class="border p-3">
                            <pie-chart :chart-data="chart_data" :options="chart_options"></pie-chart>
                        </div>
                    </div>
                    <div class="col-lg-8">
                        <b-tabs content-class="p-3">
                            <b-tab title="Nataasri">
                                <h4>Endpoint</h4>
                                <ul class="list-unstyled">
                                    <li class="border p-3 mb-3">
                                        <a href="#">{{ nata1Api }}</a>
                                        <br>
                                        <br>
                                        <button class="btn btn-sm btn-success" @click="testApi(nata1Api, 'nata1')">
                                            Health Check
                                        </button>
                                        <button class="btn btn-sm btn-outline-success ms-2" v-if="nata1 === true"><i class="fa fa-check"></i> UP</button>
                                        <button class="btn btn-sm btn-outline-danger ms-2" v-if="nata1 === false"><i class="fa fa-times"></i> DOWN</button>
                                        <hr>
                                        <b>Statiun/Alat:</b>
                                        <ul>
                                            <li v-for="(station, index) in nata1_stations" :key="index">{{ station }}</li>
                                        </ul>
                                    </li>
                                    <li class="border p-3 mb-3">
                                        <a href="#">{{ nata2Api }}</a>
                                        <br>
                                        <br>
                                        <button class="btn btn-sm btn-success" @click="testApi(nata2Api, 'nata2')">
                                            Health Check
                                        </button>
                                        <button class="btn btn-sm btn-outline-success ms-2" v-if="nata2 === true"><i class="fa fa-check"></i> UP</button>
                                        <button class="btn btn-sm btn-outline-danger ms-2" v-if="nata2 === false"><i class="fa fa-times"></i> DOWN</button>
                                        <hr>
                                        <b>Statiun/Alat:</b>
                                        <ul>
                                            <li v-for="(station, index) in nata2_stations" :key="index">{{ station }}</li>
                                        </ul>
                                    </li>
                                </ul>
                            </b-tab>
                            <b-tab title="Radisa">
                                <h4>Endpoint</h4>
                                <ul class="list-unstyled">
                                    <li class="border p-3 mb-3">
                                        <code>
                                            <a href="#">
                                                {{ radisa1ApiBase }}<i class="text-secondary">,start_time,end_time</i>
                                            </a>
                                            <br>
                                            <br>
                                            <span class="text-secondary">format start_time dan end_time adalah: YYYY-MM-DD HH:mm, contoh {{ current_time }}</span>
                                        </code>
                                        <br>
                                        <br>
                                        <button
                                            class="btn btn-sm btn-success"
                                            @click="testApi(`${radisa1ApiBase},${radisa_date_range}`, 'radisa1')
                                        ">
                                            Health Check
                                        </button>
                                        <button class="btn btn-sm btn-outline-success ms-2" v-if="radisa1 === true"><i class="fa fa-check"></i> UP</button>
                                        <button class="btn btn-sm btn-outline-danger ms-2" v-if="radisa1 === false"><i class="fa fa-times"></i> DOWN</button>
                                        <hr>
                                        <b>Statiun/Alat:</b>
                                        <ul>
                                            <li v-for="(station, index) in radisa1_stations" :key="index">{{ station }}</li>
                                        </ul>
                                    </li>
                                    <li class="border p-3 mb-3">
                                        <code>
                                            <a href="#">
                                                {{ radisa2ApiBase }}<i class="text-secondary">,start_time,end_time</i>
                                            </a>
                                            <br>
                                            <br>
                                            <span class="text-secondary">format start_time dan end_time adalah: YYYY-MM-DD HH:mm, contoh {{ current_time }}</span>
                                        </code>
                    
                                        <br>
                                        <br>
                                        <button
                                            class="btn btn-sm btn-success"
                                            @click="testApi(`${radisa2ApiBase},${radisa_date_range}`, 'radisa2')
                                        ">
                                            Health Check
                                        </button>
                                        <button class="btn btn-sm btn-outline-success ms-2" v-if="radisa2 === true"><i class="fa fa-check"></i> UP</button>
                                        <button class="btn btn-sm btn-outline-danger ms-2" v-if="radisa2 === false"><i class="fa fa-times"></i> DOWN</button>
                                        <hr>
                                        <b>Statiun/Alat:</b>
                                        <ul>
                                            <li v-for="(station, index) in radisa2_stations" :key="index">{{ station }}</li>
                                        </ul>
                                    </li>
                                </ul>
                            </b-tab>
                            <b-tab title="Beacon">
                                <h4>Endpoint</h4>
                                <ul class="list-unstyled">
                                    <li class="border p-3 mb-3">
                                        <code>
                                            <a href="#">
                                                {{ beaconApi }}
                                            </a>
                                            <br>
                                            <br>
                                            <span class="text-secondary">
                                                Login dengan menggunakan akun:<br />
                                                username: jasatirta2<br />
                                                password: ASK DEVELOPER
                                            </span>
                                        </code>
                                        <br>
                                        <br>
                                        <button
                                            class="btn btn-sm btn-success"
                                            @click="testBeaconApi()
                                        ">
                                            Health Check
                                        </button>
                                        <button class="btn btn-sm btn-outline-success ms-2" v-if="beacon === true"><i class="fa fa-check"></i> UP</button>
                                        <button class="btn btn-sm btn-outline-danger ms-2" v-if="beacon === false"><i class="fa fa-times"></i> DOWN</button>
                                        <hr>
                                        <b>Statiun/Alat:</b>
                                        <ul>
                                            <li v-for="(station, index) in beacon_stations" :key="index">{{ station }}</li>
                                        </ul>
                                    </li>
                                </ul>
                            </b-tab>
                            <b-tab title="Higertech">
                                <h4>Endpoint</h4>
                                <ul class="list-unstyled">
                                    <li class="border p-3 mb-3">
                                        <code>
                                            <a href="#">
                                                {{ higertechApiBase }}/<span class="text-secondary">DEVICE_ID</span>
                                            </a>
                                            <br>
                                            <br>
                                            <span class="text-secondary">
                                                DEVICE_ID contohnya <i>HGT1023</i>. bisa dilihat di daftar alat
                                            </span>
                                        </code>
                                        <br>
                                        <br>
                                        <button
                                            class="btn btn-sm btn-success"
                                            @click="testHigertechApi(`${higertechApiBase}/HGT1023`)
                                        ">
                                            Health Check
                                        </button>
                                        <button class="btn btn-sm btn-outline-success ms-2" v-if="higertech === true"><i class="fa fa-check"></i> UP</button>
                                        <button class="btn btn-sm btn-outline-danger ms-2" v-if="higertech === false"><i class="fa fa-times"></i> DOWN</button>
                                        <hr>
                                        <b>Statiun/Alat:</b>
                                        <ul>
                                            <li v-for="(station, index) in higertech_stations" :key="index">{{ station }}</li>
                                        </ul>
                                    </li>
                                </ul>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </section>
        </main>
    </div>

</template>

<script>
// import
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import Breadcrumb from '../../components/Breadcrumb.vue'
// Component
import Navbar from '../../components/Navbar.vue'
import SidebarSpatial from '../../components/SidebarTelemeteri.vue'
import Datepicker from 'vuejs-datepicker'
import VueTimepicker from 'vue2-timepicker'
  import moment from 'moment'
import {BTab, BTabs} from 'bootstrap-vue';
import PieChart from '../../components/chart/PieChart.vue'

const NATA1_API = process.env.VUE_APP_TELEMETERI_DOC_NATA1_API;
const NATA2_API = process.env.VUE_APP_TELEMETERI_DOC_NATA2_API;
const RADISA1_API = process.env.VUE_APP_TELEMETERI_DOC_RADISA1_API;
const RADISA2_API = process.env.VUE_APP_TELEMETERI_DOC_RADISA2_API;
const BEACON_API = process.env.VUE_APP_TELEMETERI_DOC_BEACON_API;
const HIGERTECH_API = process.env.VUE_APP_TELEMETERI_DOC_HIGERTECH_API;

export default {
    name: 'TelemtriDiagnostic',
    components: {
        Breadcrumb,
        Navbar,
        SidebarSpatial,
        Loading,
        Datepicker,
        VueTimepicker,
        BTabs,
        BTab,
        PieChart
    },
    data() {
        return {
            is_loading: false,
            nata1: null,
            nata2: null,
            radisa1: null,
            radisa2: null,
            beacon: null,
            higertech: null,
            nata1_stations: [
                "Cilamaya",
                "Forebay  Pompa Tarum Barat",
                "Bendung Bekasi",
                "Cipunagara",
                "Cisomang",
                "Tarum Timur ( B.Tt.53 )",
                "Cisomang 2",
            ],
            nata2_stations: [
                "Sungai Citarum (Sapan)",
                "Cilalawi",
                "Sungai Citarum (Majalaya)",
                "Cisomang",
                "Sungai Citarum (Dayeuhkolot)",
                "Cisomang 2",

            ],
            radisa1_stations: [
                "B. Tt. 23 (Pabuaran)",
                "Bendung Cikeas (Koja)",
                "Siphon Bekasi (Hilir B. Tb. 45)",
                "B.Tb.35a",
                "BBU Bugis (Udik)",
                "DAS Bekasi (Sentul)",
                "Bendung Cikarang (Udik)",
                "Sungai Cileungsi (Jembatan Wika)",
                "Sungai Cileungsi (Villa Nusa Indah)",
                "Bendung Cibeet",
                "Muara 7 sungai Cipunegara",
                "Bendung Gadung",
                "Bendungan Kamojing",
                "B.Tb.23",
                "Radial Gate Ubrug",
                "Tailrace",
                "Hulu Sungai Cikarang",
                "Bendung Cipamingkis",
                "Sungai Cilemah Abang",
                "INTAKE TARUM UTARA",
                "Sungai Cilamaya",
                "Inlet Waduk Cipancuh",
                "Sungai Ciasem",
                "Bendung Macan",
            ],
            radisa2_stations: [
                "Pos Duga Air Leuwigoong",
                "Pos Duga Air Bojongloa",
                "Pos Duga Air Cibatu",
                "Pos Duga Air Cibodas",
                "Pos Duga Air Jatiwangi",
                "Pos Duga Air Baok",
                "Pos Duga Air Cibinuang",
                "Pos Curah Hujan Pamulihan",
                "Pos Curah Hujan Tarogong",
            ],
            beacon_stations: [
                "Pos AWLR Bendung Jabung",
                "Pos AWLR Datar Lebuay",
                "Pos AWLR Bendung Ajibaru",
                "Pos AWLR Gunung Raya",
                "Pos AWLR Gunung Pasir Jaya",
                "Pos AWLR Desa Gedung Gumanti",
                "Pos AWLR Bumi Agung",
                'Pos AWLR Way Sekampung',
                'Pos AWLR Asahan',
                'Pos AWLR Way Seputih',
                'Pos AWLR Pengubuan',
                'Pos AWLR Way Durian',
                'Pos AWLR Way Semah',
                'Pos AWLR Way Galih',
                'Pos AWLR Way Ketibung',

            ],
            higertech_stations: [
                'AWLR B.TUT 4 CABANG TIMUR (HGT1023)',
                'ARR HULU CILEUNGSI (HGT1028)',
                'ARR HULU CIPAMINGKIS (HGT1029)',
                'AWLR BENDUNG LEUWINANGKA BARU (HGT1027)',
                'AWLR CURUG AGUNG (HGT1025)',
                'AWLR B.TUB 15 CABANG BARAT (HGT1021)',
                'AWLR B.TUT 8 CABANG TIMUR (HGT1022)',
                'AWLR B.TUB 10 CABANG BARAT (HGT1020)',
                'AWLR SALURAN SEKUNDER BERES (B.BRS.2) (HGT1026)',
                'AWLR CIBEET (KALI ALAM) (HGT1019)',
                'ARR HULU CIBEET (HGT1030)',
                'ARR HULU CIKAO (HGT1031)',
                'ARR BENDUNG LEUWINANGKA BARU (HGT1018)',
                'AWLR SUNGAI CIPUNAGARA (HGT1024)',

            ],
            chart_options: {
                responsive: true,
                maintainAspectRatio: false
            },
            chart_data: {
                labels: ["Nataasri", "Radisa", "Beacon"],
                datasets: [{
                    data: [13, 33, 7],
                    backgroundColor: [
                        "#FF6384", // warna untuk Nataasri
                        "#36A2EB", // warna untuk Radisa
                        "#FFCE56"  // warna untuk Beacon
                    ]
                }]
            },
            nata1Api: NATA1_API,
            nata2Api: NATA2_API,
            radisa1ApiBase: RADISA1_API,
            radisa2ApiBase: RADISA2_API,
            beaconApi: BEACON_API,
            higertechApiBase: HIGERTECH_API,
        }
    },
    methods: {
        async testApi(url, target){
            this.is_loading = true;

            try {
                const response = await axios.post(`${this.$endpoints.telemeteri}/proxy`, {
                    url
                });

                this[target] = true;
            } catch (error) {
                this[target] = false;
            }

            this.is_loading = false;
        },
        async testBeaconApi(){
            this.is_loading = true;

            try {
                const response = await axios.get(`${this.$endpoints.telemeteri}/proxy/beacon`);

                this.beacon = true;
            } catch (error) {
                this.beacon = false;
            }

            this.is_loading = false;
        },
        async testHigertechApi(url) {
            try {
                const response = await axios.post(`${this.$endpoints.telemeteri}/proxy`, {
                    url
                });

                this.higertech = true;
            } catch (error) {
                this.higertech = false;
            }

            this.is_loading = false;
        }
    },
    computed: {
        date_start(){
            return moment().subtract(1, "hours").format("YYYY-MM-DD HH:mm");
        },
        date_end(){
            return moment().format("YYYY-MM-DD HH:mm");
        },
        radisa_date_range(){
            return `${this.date_start},${this.date_end}`;
        },
        current_time(){
            return moment().format('YYYY-MM-DD HH:mm');
        }
    }
}

</script>

<style>
.vue__time-picker,
.vue__time-picker input{
    width: 100%!important;
    height: 2.5em
}
</style>
